// Copyright 2026, Imprivata, Inc.  All rights reserved.

import Markdown from 'react-markdown';

const MAX_LEN = 8 * 1024;
const ALLOWED = ['p', 'strong', 'em', 'code', 'ul', 'ol', 'li', 'a', 'br'];

const safeUrl = (url?: string): string => {
  if (!url) {
    return '';
  }
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'https:' || parsed.protocol === 'mailto:') {
      return parsed.toString();
    }
  } catch {
    return '';
  }
  return '';
};

type Props = { source: string };

const MarkdownMessage = ({ source }: Props) => {
  const truncated = source.length > MAX_LEN;
  const text = truncated ? `${source.slice(0, MAX_LEN)}…` : source;

  return (
    <Markdown
      allowedElements={ALLOWED}
      unwrapDisallowed
      urlTransform={safeUrl}
      components={{
        // urlTransform (safeUrl) blanks out disallowed URLs. An empty href
        // would still render as a clickable link, so degrade to plain text.
        a: ({ href, children }) =>
          href ? (
            <a href={href} target="_blank" rel="noopener noreferrer nofollow">
              {children}
            </a>
          ) : (
            children
          ),
      }}
    >
      {text}
    </Markdown>
  );
};

export default MarkdownMessage;
